import React from 'react';
import { css } from 'styled-components';
import { Typo } from 'src/components/common/ui';
import Layout from 'src/components/common/theme/Layout';
import { checkValue } from 'src/components/functions';

interface ModuleTitleProps {
  children: React.ReactNode;
  size?: 'M' | 'L';
  color?: string;
  exClass?: string;
  textAlign?: 'lt' | 'ctr' | 'rt';
}

const ModuleTitle = (props: ModuleTitleProps) => {
  const { children, size = "M", color, exClass, textAlign = "ctr" } = props;

  const moduleCss = () => {
    return `
        ${
          checkValue(color)
            ? `.v2-module-title {
            color: ${color} !important;
        }            
        `
            : ''
        }`;
  };

  return (
    <Layout
      css={css`
        ${moduleCss()}
      `}
      className="v2-module-title-container"
      HtmlTag="div"
    >
      <Typo.HTMLText exClass={`v2-module-title ${textAlign} ${exClass}`} tag={`${size === 'M' ? 'h2' : 'h1'}`}>
        {children}
      </Typo.HTMLText>
    </Layout>
  );
};

export default ModuleTitle;
